import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ gridColumn: `span ${Math.min(_ctx.numColumns(), _ctx.span)}` })
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 4 /* STYLE */))
}